// extracted by mini-css-extract-plugin
module.exports = {"non-wound-study-badge-container":"style_non-wound-study-badge-container__IbNBx"};